import { render, staticRenderFns } from "./BuyAgreement.vue?vue&type=template&id=cce40ec4"
import script from "./BuyAgreement.vue?vue&type=script&lang=js"
export * from "./BuyAgreement.vue?vue&type=script&lang=js"
import style0 from "./BuyAgreement.vue?vue&type=style&index=0&id=cce40ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports